import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';
import { EnumDescriptor } from '../../enum-descriptor';
import { ProviderState } from 'src/app/proxy/providers';

@Component({
  selector: 'app-provider-state-dropdown',
  templateUrl: './provider-state-dropdown.component.html',
  standalone: false,
})
export class ProviderStateDropdownComponent extends AppBaseComponent implements OnInit {
  @Input() isRequired: boolean;
  @Input() providerState: ProviderState;

  @Output() changeProviderState = new EventEmitter<ProviderState>();

  providerStates: EnumDescriptor[];

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    if (this.isNullOrUndefined(this.providerState)) {
      this.providerState = ProviderState.Active;
    }

    this.loadProviderState();
    this.onSelected();
  }

  loadProviderState(): void {
    this.providerStates = this.getEnumOptions(ProviderState, false);
  }

  setSelectedState(state: ProviderState | undefined): void {
  this.providerState = state;
  this.onSelected();
  }

  onSelected(): void {
    this.changeProviderState.emit(this.providerState);
  }
}